export enum ServiceStatus {
    InfoRequested,
    ReadyToSubmit,
    Submitted,
}
